module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Divieto_di_Transito-BN-CL.109b4e93.svg";